module.exports = __webpack_public_path__ + "assets/img/completed.5f961c9d.png";